// PersoenlicherKontaktPille.tsx — „Persönlicher Kontakt von …" als Pille im
// Pillen-Band der Kontaktakte (`.verantrow`), auf derselben Ebene wie FO und BO
// (Wunsch 28.09.2026). Feld: `Contact.inhouseContactUserId`.
//
// Bauart und Menü wie die FO/BO-Pillen (`VerantwortlichChip`), nur mit eigenem
// Präfix und eigener Überschrift; die Hash-Farbe hängt an der User-Id, damit
// die Person denselben Ton trägt wie als FO. Speichern übernimmt der
// Aufrufer (`onChange`) — die Pille selbst kennt keinen Endpunkt.

import * as React from "react";

import { VerantwortlichChip, type VerantwortlichOption } from "./VerantwortlichChip";

export interface PersoenlicherKontaktPilleProps {
  /** User-Id aus `inhouseContactUserId` ("" = keiner). */
  userId: string;
  /** Wählbare Mitarbeiter (alle User des Mandanten). */
  optionen: VerantwortlichOption[];
  /** Ohne Schreibrecht: statische Pille; ohne Zuordnung dann gar keine Pille. */
  editable?: boolean;
  onChange?: (userId: string) => void;
}

export function PersoenlicherKontaktPille({
  userId,
  optionen,
  editable,
  onChange,
}: PersoenlicherKontaktPilleProps) {
  const name = userId ? optionen.find((o) => o.id === userId)?.name || "Unbekannter Nutzer" : "";
  // Nur lesend und nichts eingetragen: kein Platz im Band verschenken.
  if (!editable && !name) return null;
  return (
    <VerantwortlichChip
      art="FO"
      praefix="Persönlicher Kontakt von"
      bezeichnung="Persönlicher Kontakt von"
      wert={name}
      gewaehlt={userId}
      farbschluessel={userId}
      optionen={optionen}
      leerText="niemandem"
      leerOption="Keine Auswahl"
      editable={editable}
      onChange={onChange}
    />
  );
}

export default PersoenlicherKontaktPille;
